module.exports = __webpack_public_path__ + "img/logo.bbc94f79.png";